// test632
(632 && 0);
